import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { schedularTherapistFilterAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* maintainTherpaistFilter(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.maintainTherapistFilter,
      action.payload
    );

    if (response?.status === 201) {
      yield put({
        type: schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_SUCCESS,
        payload: response.data,
      });

      yield put({
        type: schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_REQUEST,
        payload: action.payload,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_FAILURE,
      payload: error,
    });
  }
}

function* maintainTherapistFilterSaga() {
  yield takeEvery(
    schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_REQUEST,
    maintainTherpaistFilter
  );
}

export default maintainTherapistFilterSaga;
